/**
 * Pharmacy module-details request/response shapes.
 * Mirrors backend/src/modules/pharmacy/pharmacy.validators.ts.
 */

// Indian drug license formats vary by state. Allow alphanumeric +
// dash, slash, dot, and spaces. Length 5..60 chars after trim.
export const DRUG_LICENSE_REGEX = /^[A-Za-z0-9\-/.\s]+$/;
export const DRUG_LICENSE_MIN = 5;
export const DRUG_LICENSE_MAX = 60;

export type PharmacyDetailsRequest = {
  drug_license_number: string;
};

export type PharmacyDetailsResponse = {
  id: string;
  vendor_profile_id: string;
  drug_license_number: string;
  created_at: string;
  updated_at: string;
};
